import { keyframes } from "styled-components";

const gradient = () => keyframes`
  0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`;

const blink = () => keyframes`
  0% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
`;

const flameRise = () => keyframes`
	from {
		opacity: 0;
		transform: translateY(0) scale(1);
	}

	25% {
		opacity: 1;
	}

	to {
		opacity: 0;
		transform: translateY(-30px) scale(0);
	}
`;

const Keyframes = {
  gradient,
  blink,
  flameRise,
};

export default Keyframes;
